import React from 'react'

type props = {
  color?: string
}

export const Preloader: React.FC<props> = (props) => {
  return (
    <div className="preloader">
      <svg>
        <circle style={{stroke: props.color}} cx={'8'} cy={'8'} r={'8'} />
      </svg>
    </div>
  )
}
